import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
        data: { titulo: 'Início', breadcrumb: 'Início' },
      },
      {
        path: 'acesso-negado',
        loadComponent: () => import('./pages/acesso-negado/acesso-negado.component').then((m) => m.AcessoNegadoComponent),
      },
      {
        path: '',
        loadChildren: () => import('./pages/cadastros/cadastros.routes').then((m) => m.cadastrosRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/planejamento/planejamento.routes').then((m) => m.planejamentoRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/suprimentos/suprimentos.routes').then((m) => m.suprimentosRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/almoxarifado/almoxarifado.routes').then((m) => m.almoxarifadoRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/execucao/execucao.routes').then((m) => m.execucaoRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/financeiro/financeiro.routes').then((m) => m.financeiroRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/relatorios/relatorios.routes').then((m) => m.relatoriosRoutes),
      },
      {
        path: '',
        loadChildren: () => import('./pages/manual-sistema/manual-sistema.routes').then((m) => m.manualSistemaRoutes),
      },
      { path: '404', loadComponent: () => import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent) },
      { path: '**', redirectTo: '404' }
    ]
  }
];
